/* eslint-disable react/jsx-handler-names */
/* es lint rule "react/jsx-handler-names" does not appear to work correctly in files organized like this. */

'use strict';
import React from 'react';
import * as T from 'prop-types';
import IonSpinner from '../../../_libs/reactionic/src/components/ionSpinner';
import {I18nComponent} from '../../../core-utilities/react-i18n/I18nComponent';
import {InviteLoginStatuses} from '../../enums/InviteLoginStatuses';

export function BaseInvitationLoginView(props) {
  let body = null;
  switch (props.mode) {
    case InviteLoginStatuses.LOADING:
      body = renderLoading(props);
      break;

    case InviteLoginStatuses.NO_CODE:
      body = renderNoCode(props);
      break;

    case InviteLoginStatuses.EXPIRED_CODE:
    case InviteLoginStatuses.REQUESTING_CODE:
      body = renderExpiredCode(props, props.mode === InviteLoginStatuses.REQUESTING_CODE);
      break;

    case InviteLoginStatuses.REQUESTING_CODE_SUCCESS:
    case InviteLoginStatuses.REQUESTING_CODE_ERROR:
      body = renderCodeRequested(props, props.mode === InviteLoginStatuses.REQUESTING_CODE_SUCCESS);
      break;

    case InviteLoginStatuses.NO_INVITE:
      body = renderNoInvite(props);
      break;

    case InviteLoginStatuses.VALID_CODE_NEED_AUTH:
      body = renderValidCodeNeedAuth(props);
      break;

    case InviteLoginStatuses.VALID_CODE_HAVE_AUTH:
      body = renderValidCodeHaveAuth(props);
      break;

    case InviteLoginStatuses.ERROR:
    default:
      body = renderError(props);
      break;
  }

  return (
    <div className="wizard">
      {body}
    </div>
  );
}

function renderWelcomeBanner(props) {
  return (
    <div className="welcome">
      {props.welcomeHeader}
    </div>
  );
}

function renderGoToLogin(props) {
  return (
    <div>
      <div
        className="register new-code"
        onClick={props.goToLogin}
      >
        <div>
          {props.goToLoginLabel}
        </div>
        <i className="icon ion-ios-arrow-forward" />
      </div>
    </div>
  );
}

function renderLoading(props) {
  return (
    <div className="wizard setup-section setup-new-user">
      <div className="loading-message">
        <div>
          {props.loadingLabel}
        </div>
        <IonSpinner icon="spiral" />
      </div>
    </div>
  );
}

function renderNoCode(props) {
  return (
    <div className="wizard setup-section setup-new-user">
      {renderWelcomeBanner(props)}
      <div>
        <div>
          <span>
            {props.dneMessage}
          </span>
        </div>
      </div>
      {renderGoToLogin(props)}
    </div>
  );
}

function renderExpiredCode(props, isRequesting) {
  // TODO: add mode for request code failure. use response:
  // Please request a new invitation from the person who invited you.
  return (
    <div className="wizard setup-section setup-new-user">
      {renderWelcomeBanner(props)}
      <div>
        <div>
          {props.invitationMessage}
        </div>
        <div>
          <span>
            {props.expiredHeader}
          </span>
        </div>
      </div>
      <div>
        <div
          className="register new-code"
          onClick={props.requestNewCode}
        >
          <div>
            {isRequesting ? props.requestingLabel : props.requestPromptLabel}
          </div>
          {isRequesting ? <IonSpinner icon="spiral" /> : <i className="icon ion-ios-arrow-forward" />}
        </div>
      </div>
    </div>
  );
}

function renderCodeRequested(props, isSuccess) {
  return (
    <div className="wizard setup-section setup-new-user">
      {renderWelcomeBanner(props)}
      <div>
        <div>
          {props.invitationMessage}
        </div>
        <div>
          <span>
            {isSuccess ? props.requestSuccessMessage : props.requestErrorMessage}
          </span>
        </div>
      </div>
      {renderGoToLogin(props)}
    </div>
  );
}

function renderNoInvite(props) {
  return (
    <div className="wizard setup-section setup-new-user">
      {renderWelcomeBanner(props)}
      <div>
        <div>
          <span>
            {props.dneMessage}
          </span>
          <br />
          <span>
            {props.requestContactMessage}
          </span>
        </div>
      </div>
      {renderGoToLogin(props)}
    </div>
  );
}

// Offer user the option to sign in with an existing account or create a new one
function renderValidCodeNeedAuth(props) {
  return (
    <div className="wizard setup-section setup-new-user">
      {renderWelcomeBanner(props)}
      <div>
        <div>
          {props.invitationMessage}
        </div>
      </div>

      <div className="space-bottom">
        <div>
          {props.newUserMessage}
        </div>
        <div
          className="login"
          onClick={props.signUp}
        >
          <div>
            {props.signupMessage}
          </div>
          <i className="icon ion-ios-arrow-forward" />
        </div>
      </div>
      <div>
        <div>
          {props.haveAccountMessage}
        </div>
        <div
          className="login"
          onClick={props.login}
        >
          <div>
            {props.loginLabel}
          </div>
          <i className="icon ion-ios-arrow-forward" />
        </div>
      </div>
    </div>
  );
}

function renderValidCodeHaveAuth(props) {
  // TODO: perhaps inform user they are being redirected in case something hangs?
  return renderLoading(props);
}

function renderError(props) {
  return (
    <div className="wizard setup-section setup-new-user">
      {renderWelcomeBanner(props)}
      <div>
        <div>
          <span>
            {props.errorMessage}
          </span>
        </div>
      </div>
      {renderGoToLogin(props)}
    </div>
  );
}

BaseInvitationLoginView.propTypes = {
  className: T.string,
  mode: T.oneOf(Object.keys(InviteLoginStatuses)),
  signUp: T.func,
  login: T.func,
  goToLogin: T.func,
  requestNewCode: T.func,

  organizationName: T.string,
  inviterName: T.string,

  welcomeHeader: T.string,
  goToLoginLabel: T.string,
  loadingLabel: T.string,
  expiredHeader: T.string,
  requestPromptLabel: T.string,
  requestingLabel: T.string,
  requestSuccessMessage: T.string,
  requestErrorMessage: T.string,
  requestContactMessage: T.string,
  dneMessage: T.string,
  invitationMessage: T.string,
  newUserMessage: T.string,
  signupMessage: T.string,
  haveAccountMessage: T.string,
  welcomeMessage: T.string,
  errorMessage: T.string,
};

BaseInvitationLoginView.defaultProps = {
  className: '',
  mode: 'loading',
};

export const InvitationLoginView = I18nComponent(BaseInvitationLoginView, [
  {code: 'default.loading.label', prop: 'loadingLabel'},
  {code: 'onboarding.welcome.header', prop: 'welcomeHeader'},
  {code: 'onboarding.welcome.invitation', prop: 'invitationMessage', params: getInvitationParams},
  {code: 'onboarding.welcome.newuser', prop: 'newUserMessage'},
  {code: 'onboarding.welcome.signup', prop: 'signupMessage'},
  {code: 'onboarding.welcome.have.account', prop: 'haveAccountMessage'},
  {code: 'onboarding.welcome.login', prop: 'loginLabel'},
  {code: 'onboarding.welcome.to.login', prop: 'goToLoginLabel'},
  {code: 'onboarding.invite.expired.header', prop: 'expiredHeader'},
  {code: 'onboarding.invite.request.prompt.message', prop: 'requestPromptLabel'},
  {code: 'onboarding.invite.request.progress.message', prop: 'requestingLabel'},
  {code: 'onboarding.invite.request.success.message', prop: 'requestSuccessMessage'},
  {code: 'onboarding.invite.request.error.message', prop: 'requestErrorMessage'},
  {code: 'onboarding.invite.request.contact.message', prop: 'requestContactMessage'},
  {code: 'onboarding.invite.dne.message', prop: 'dneMessage'},
  {code: 'onboarding.error.message', prop: 'errorMessage'},
]);

function getInvitationParams(props) {
  return {
    organizationName: props.organizationName,
    inviterName: props.inviterName,
  };
}



// WEBPACK FOOTER //
// ./src/js/auth/components/InvitationLogin/InvitationLoginView.js